import { useEffect, useRef, useState } from 'react'
import logo from '../assets/logo.png'

export default function Header() {
    const [isVisible, setIsVisible] = useState(true)
    const lastScrollY = useRef(0)
    const visibilityThreshold = 120

    useEffect(() => {
        if (typeof window === 'undefined') return
        const handleScroll = () => {
            const currentScrollY = window.scrollY

            if (currentScrollY <= visibilityThreshold) {
                setIsVisible(true)
            } else if (currentScrollY > lastScrollY.current) {
                setIsVisible(false)
            } else if (currentScrollY < lastScrollY.current) {
                setIsVisible(true)
            }

            lastScrollY.current = currentScrollY
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <>
            <header className={`py-3 z-50 top-0 left-0 right-0 w-full sticky bg-black/80 backdrop-blur-sm border-b border-white/15 transition-transform duration-500 ease-out will-change-transform ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                <div className="container mx-auto px-3 sm:px-5 flex items-center justify-between">
                    {/* Logo */}
                    <a href='/' className="flex items-center">
                        <img src={logo} alt="logo" className='w-[70px] h-auto rounded-[4px]' />
                    </a>
                    {/* Action Buttons */}
                    <div className="flex items-center gap-3">
                        {/* Search Button */}
                        <a href="https://wa.me/447478034690" className="rounded-full text-black font-semibold bg-yellow-400 hover:bg-yellow-300 flex items-center justify-center gap-2 transition-all duration-300 hover:scale-105 shadow-lg px-2 sm:px-3 py-2 text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 sm:w-5 sm:h-5' viewBox="0 0 24 24"><g fill="#000"><path fill-rule="evenodd" d="M12 4a8 8 0 0 0-6.895 12.06l.569.718l-.697 2.359l2.32-.648l.379.243A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-5.016-1.347l-4.948 1.382l1.426-4.829l-.006-.007l-.033-.055A9.96 9.96 0 0 1 2 12" clip-rule="evenodd"/><path d="M16.735 13.492c-.038-.018-1.497-.736-1.756-.83a1 1 0 0 0-.34-.075c-.196 0-.362.098-.49.291c-.146.217-.587.732-.723.886c-.018.02-.042.045-.057.045c-.013 0-.239-.093-.307-.123c-1.564-.68-2.751-2.313-2.914-2.589c-.023-.04-.024-.057-.024-.057c.005-.021.058-.074.085-.101c.08-.079.166-.182.249-.283l.117-.14c.121-.14.175-.25.237-.375l.033-.066a.68.68 0 0 0-.02-.64c-.034-.069-.65-1.555-.715-1.711c-.158-.377-.366-.552-.655-.552c-.027 0 0 0-.112.005c-.137.005-.883.104-1.213.311c-.35.22-.94.924-.94 2.16c0 1.112.705 2.162 1.008 2.561l.041.06c1.161 1.695 2.608 2.951 4.074 3.537c1.412.564 2.081.63 2.461.63c.16 0 .288-.013.4-.024l.072-.007c.488-.043 1.56-.599 1.804-1.276c.192-.534.243-1.117.115-1.329c-.088-.144-.239-.216-.43-.308"/></g></svg>
                            <span className='hidden sm:block'>+44 7478034690</span>
                        </a>
                        
                        {/* Login Button */}
                        <a href="https://wa.me/447478034690?text=Prueba%20IPTV,%20por%20favor." className="bg-transparent border-2 border-white text-white px-6 py-2 rounded-full font-semibold text-sm transition-all duration-300 hover:bg-white hover:text-black hidden sm:block">
                            Prueba Gratuita
                        </a>
                    </div>
                </div>
            </header>

            {/* WhatsApp Floating Button - Fixed Bottom Right */}
            <a
                href="https://wa.me/447478034690"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 rounded-full flex items-center justify-center shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 group animate-bounce"
                aria-label="Contacter sur WhatsApp"
            >
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="32" 
                    height="32" 
                    viewBox="0 0 24 24" 
                    className="text-white"
                >
                    <path 
                        fill="currentColor" 
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15c-.197.297-.767.966-.94 1.164c-.173.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.018-.458.13-.606c.134-.133.298-.347.446-.52c.149-.174.198-.298.298-.497c.099-.198.05-.371-.025-.52c-.075-.149-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51c-.173-.008-.371-.01-.57-.01c-.198 0-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479c0 1.462 1.065 2.875 1.213 3.074c.149.198 2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625c.712.227 1.36.195 1.871.118c.571-.085 1.758-.719 2.006-1.413c.248-.694.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214l-3.741.982l.998-3.648l-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
                    />
                </svg>
                
                {/* Notification Badge */}
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-400 rounded-full flex items-center justify-center border-2 border-white">
                    <span className="w-2 h-2 bg-black rounded-full animate-pulse"></span>
                </span>
            </a>
        </>
    )
}